var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUxcore = function SvgUxcore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.85,
    d: "M6.008 2.25V1.5a4.48 4.48 0 0 0-3.186 1.318A4.47 4.47 0 0 0 1.502 6c0 1.202.469 2.331 1.32 3.182a4.48 4.48 0 0 0 3.186 1.317v-.75a3.73 3.73 0 0 1-2.656-1.098 3.73 3.73 0 0 1-1.1-2.652c0-1.001.39-1.943 1.1-2.651A3.73 3.73 0 0 1 6.008 2.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.85,
    d: "M6.009 7.875c1.036 0 1.877-.84 1.877-1.875s-.84-1.875-1.878-1.875c-1.036 0-1.877.84-1.877 1.875s.84 1.875 1.877 1.875"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.85,
    d: "M11.252 6.38a5.23 5.23 0 0 1-1.066 2.807 5.24 5.24 0 0 1-2.433 1.765c-.967.34-2.006.39-3.003.146a5.25 5.25 0 0 1-2.592-1.523A5.23 5.23 0 0 1 .825 6.884a5.23 5.23 0 0 1 .363-2.98 5.24 5.24 0 0 1 1.938-2.295A5.25 5.25 0 0 1 6.008.75V0a6 6 0 0 0-3.292.981A6 6 0 0 0 .501 3.603 5.98 5.98 0 0 0 .086 7.01a6 6 0 0 0 1.523 3.076 6 6 0 0 0 2.962 1.739A6.005 6.005 0 0 0 12 6.435zM11.958 5.169a5.96 5.96 0 0 0-1.58-3.286l-.544.515a5.22 5.22 0 0 1 1.382 2.874zM9.813 1.357a6 6 0 0 0-.661-.47l-.392.64q.302.184.578.41z"
  })));
};
export default SvgUxcore;